/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import styles from './ConsumptionTable.module.css';
import { FormattedConsumptionTable } from 'model';
import { FloTable } from 'components';
import { CSVLink } from 'react-csv';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from "react-i18next";

type ConsumptionTableProps = {
  tableData: FormattedConsumptionTable,
}

export const ConsumptionTable: React.FC<ConsumptionTableProps> =  React.memo(({
  tableData,
}) => {
  const { t } = useTranslation();

  return (
    <Row className={styles.root}>
      <Col xs="12">
        <Row>
          <Col xs="12">
            <CSVLink className={styles.button} data={tableData.download} filename={"flo-water-usage.csv"}>{t('download-as-CSV')}</CSVLink>
          </Col>
          <Col xs="12">
            <FloTable
              className   = {styles.table}
              columns     = {tableData.columns}
              data        = {tableData.data}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
});